import * as types from "../actions/types.js";
import Routes from "../../api/routes";
// API endpoint routes
import { get } from "../../api";
const { VEHICLES, VEHICLES_AVAILABILITY } = Routes;

/*******************
@purpose :  get vehicle detail data
@Parameter : {}
@Author : INIC
******************/
export const getVehicalDetailData =
  (locationId, slug, make, category) =>
    (dispatch) => {
      return get(
        `${VEHICLES}/${slug}?make=${make || ""}&category=${category || ""}&location_id=${locationId}`,
        false,
        false
      ).then((res) => {
        dispatch(setVehicleDetails(res.data));
        if (res?.data) {
          return res.data;
        }
        return Promise.reject(res);
      });
    };

/*******************
@purpose :  get available slot  using startdate
@Parameter : {localionId,vehicleId,startDate}
@Author : INIC
******************/
// Sequence of the latest calendar/time-picker availability request. The
// store holds a single vehicleSlot shared by every vehicle page, so only the
// newest request may write it: a slower response for a vehicle the customer
// has already left (or an older range of the same vehicle) is dropped from
// the store instead of overwriting newer data. "submit" checks are excluded -
// they validate a chosen range and the time pickers ignore them.
let latestSlotRequestId = 0;

export const getAvailableSlot =
  (locationId, vehicleId, startDate, endDate, flag, start_date, startTime, endTime, loader = false) =>
    (dispatch) => {
      const isSubmit = flag === "submit";
      const requestId = isSubmit ? null : ++latestSlotRequestId;
      return get(
        `${VEHICLES_AVAILABILITY}?location_id=${locationId}&vehicle_id=${vehicleId}&start_date=${startDate || ""
        }&end_date=${endDate || ""
        }&event=${flag || ""}&booking_selected_date=${flag === "start_date" ? "" : start_date}&start_time=${startTime || ""}&end_time=${endTime || ""}`,
        false,
        loader
      ).then((res) => {
        if (isSubmit || requestId === latestSlotRequestId) {
          // Tag the slot map with the vehicle it belongs to so a picker can
          // tell another vehicle's availability from its own.
          dispatch(
            setVehicleAvailableSlot(res?.data ? { ...res.data, vehicle_id: vehicleId } : res?.data)
          );
        }
        if (res?.data) {
          return res.data;
        }
        return Promise.reject(res);
      });
    };

/******************** 
@purpose : Used for store logout responce and remove token in cookie
@Parameter : { }
@Author : INIC
******************/
export const setVehicleDetails = (data) => ({
  type: types.SET_VEHICLE_DATA,
  data,
});

export const setVehicleAvailableSlot = (data) => ({
  type: types.SET_VEHICLE_AVAILABLE_SLOT,
  data,
});
